import { createSlice } from '@reduxjs/toolkit';

const userAddressSlice = createSlice({
    name: 'userAddress',
    initialState: {
        isOtherAddress: false,
        selectedAddress: {},
        isSubmit: false,
        isValid: false
    },
    reducers: {
        setIsOtherAddress: (state, action) => {
            state.isOtherAddress = action.payload.isOtherAddress;
        },
        setSelectedAddress: (state, action) => {
            state.selectedAddress = action.payload.selectedAddress;
        },

        //validation
        setIsSubmit: (state, action) => {
            state.isSubmit = action.payload.isSubmit;
        },
        setIsValid: (state, action) => {
            state.isValid = action.payload.isValid;
        },
    }
})

export const { setIsOtherAddress, setSelectedAddress, setIsSubmit, setIsValid, setIsReceivingAd } = userAddressSlice.actions
export default userAddressSlice.reducer